import * as React from 'react'
import { StoreProps, castingStoreGetCustomerBoughtCouponsPackInsights } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'
import SelectableListComponent from '../../../shared/selectable-list.component'
import { PrimaryButton } from '../casting-styled.component'
import ProgressBarComponent from '../../../shared/progress-bar.component'
import { theme } from '../../../../theme'

const i18nScoped = new I18nService(require('./casting-coupon-picker.component.yml'))

export default function CastingCouponPickerComponent ({ store, data: { offeredService, coupon, renderingMode, customer } }: StoreProps) {
  const skipCouponsPack = React.useCallback(() => {
    store.setCoupon(null) // mark casting as do not want coupons packs for next events
    store.nextFocus({ closeOnMobile: true })
  }, [store])

  const agreeToUseAlreadyPaidCouponsPacks = React.useCallback(() => {
    store.nextFocus({ closeOnMobile: true })
  }, [store])

  const { totalBoughtCouponsPacksUsed, totalBoughtCouponsPacksPlanned, totalBoughtCouponsPacksQuantity, remainingBoughtCouponsPacksQuantity } = React.useMemo(() => {
    return castingStoreGetCustomerBoughtCouponsPackInsights({ customer, offeredService })
  }, [customer, offeredService])

  const simulatedProgressBarTheme = { ...theme, colors: { ...theme.colors, clr_1: theme.colors.clr_0_light } }

  return <>
    { remainingBoughtCouponsPacksQuantity <= 2 && <SelectableListComponent
      name="couponPack"
      value={ coupon }
      data={ offeredService.coupons_packs }
      formatter={ formatCouponName }
      onChange={ val => { store.setCoupon(val); store.nextFocus({ closeOnMobile: true }) } } /> }

    { totalBoughtCouponsPacksQuantity > 0 && <div className="boxPod u-mtm u-mbs u-pam">
      <div className="u-mbs">{ i18nScoped.t('customer_bought_coupons_pack') }</div>
      <div className="u-positionRelative" style={{ height: 10 }}>
        <ProgressBarComponent style={{ position: 'absolute', width: '100%' }} theme={ simulatedProgressBarTheme } max={ totalBoughtCouponsPacksQuantity } value={ totalBoughtCouponsPacksUsed + totalBoughtCouponsPacksPlanned } />
        <ProgressBarComponent style={{ position: 'absolute', width: '100%', backgroundColor: 'transparent' }} max={ totalBoughtCouponsPacksQuantity } value={ totalBoughtCouponsPacksUsed } />
      </div>
      <span className="txtSmall">{ i18nScoped.t('used_bought_coupons_pack', { count: totalBoughtCouponsPacksUsed + totalBoughtCouponsPacksPlanned, quantity: totalBoughtCouponsPacksQuantity }) }</span>
      &nbsp;•&nbsp;
      <span className="txtSmall">{ i18nScoped.t('remaining_bought_coupons_pack', { count: remainingBoughtCouponsPacksQuantity }) }</span>
    </div> }

    <div style={{ paddingTop: '1em', textAlign: 'center' }}>
      { remainingBoughtCouponsPacksQuantity <= 0 && <PrimaryButton style={{ display: 'block' }} onClick={ skipCouponsPack }>{ i18nScoped.t('no_coupon') }</PrimaryButton> }
      { totalBoughtCouponsPacksQuantity > 0 && <>
        <p>{ i18nScoped.t('use_already_paid_coupons_pack') }</p>
        <button
          className={ `${renderingMode === 'mobile' ? 'button u-mtm u-mbm' : 'buttonNeutral button--XS'} button--main is-pulse` }
          onClick={ agreeToUseAlreadyPaidCouponsPacks }
          children={ i18nScoped.t('next') } />
      </> }
    </div>
  </> 
}

export function formatCouponName (coupon: StoreProps['data']['coupon'], withValidity = true) {
  // Fix mobile display by adding non-breaking spaces
  let displayName = `${coupon.name}: ${i18nScoped.t('hours', { count: coupon.quantity })}`.replace(/ /g, '\u00A0')

  if (withValidity) {
    displayName += ' - '
    displayName += (coupon.validity_duration_in_months ? i18nScoped.t('valid', { count: coupon.validity_duration_in_months }) : i18nScoped.t('unlimited_valid')).replace(/ /g, '\u00A0')
  }

  return displayName
}
